var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, hasNarration, hasPrompt, i18n, images, prompt, submitUp, undefined) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"content-wrapper content-fill slide-up\"><div class=\"carousel content-fill delay-6 draggy block-v-xl\"><div" + (jade.attr("style", "width:" + (images.length * 100) + "%;", true, false)) + " class=\"carousel-slider content-fill clearfix\">");
// iterate images
;(function(){
  var $$obj = images;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<div" + (jade.attr("style", "width: " + (100 / images.length) + "%;", true, false)) + " class=\"carousel-item content-fill\"><div class=\"row content-lg-fill content-sm-ver content-md-ver\">");
var size = _.compact([item.image, item.caption]).length
var cols = size == 2 ? "col-lg-6" : ""
if ( item.image)
{
buf.push("<div" + (jade.cls(['col-sm-12','content-lg-ver',cols], [null,null,true])) + ">");
jade_mixins["image"](item.image, 'img');
buf.push("</div>");
}
if ( item.caption)
{
buf.push("<div" + (jade.cls(['caption','content-fit','col-sm-12','content-lg-ver',cols], [null,null,null,null,true])) + "><div class=\"text-center text-md block-v-lg\">" + (null == (jade_interp = item.caption) ? "" : jade_interp) + "</div></div>");
}
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<div" + (jade.attr("style", "width: " + (100 / images.length) + "%;", true, false)) + " class=\"carousel-item content-fill\"><div class=\"row content-lg-fill content-sm-ver content-md-ver\">");
var size = _.compact([item.image, item.caption]).length
var cols = size == 2 ? "col-lg-6" : ""
if ( item.image)
{
buf.push("<div" + (jade.cls(['col-sm-12','content-lg-ver',cols], [null,null,true])) + ">");
jade_mixins["image"](item.image, 'img');
buf.push("</div>");
}
if ( item.caption)
{
buf.push("<div" + (jade.cls(['caption','content-fit','col-sm-12','content-lg-ver',cols], [null,null,null,null,true])) + "><div class=\"text-center text-md block-v-lg\">" + (null == (jade_interp = item.caption) ? "" : jade_interp) + "</div></div>");
}
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div>");
if ( images.length > 1)
{
buf.push("<div class=\"pagination\">");
// iterate images
;(function(){
  var $$obj = images;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var item = $$obj[i];

buf.push("<div" + (jade.attr("data-page", i, true, false)) + " class=\"dot\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var item = $$obj[i];

buf.push("<div" + (jade.attr("data-page", i, true, false)) + " class=\"dot\"></div>");
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("<div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"images" in locals_for_with?locals_for_with.images:typeof images!=="undefined"?images:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}